import { Get } from "../../../api/apiHelper";
import { Booking } from "../../../interfaces/BookingInterfaces";

const appointmentsRoot = "/api/clientportal";

async function getClientAppointments(
  clientId: number,
  from: string,
  to: string
): Promise<Booking[]> {
  const response = await Get(`${appointmentsRoot}/bookings`, true, { clientId, from, to });
  return response.data as Booking[];
}

export default getClientAppointments;
